<div class="login-page">
  <div class="login-wrapper">

    <!-- Brand mark -->
    <div class="brand-wrap">
      <img [src]="this.logoUrl" class="logo" />
    </div>

    <!-- Heading -->
    <div class="login-heading">
      <h1>Log in to your account</h1>
      <p>Welcome back. Enter your details to continue.</p>
    </div>

    <!-- Card -->
    <edu-card class="login-card">
      <!-- OIDC-only: the QLM login. While the silent prompt=none redirect is in flight,
           show a placeholder instead of the button. -->
      <div *ngIf="attemptingSilent" class="silent-login">
        <p class="silent-login-text">Signing you in…</p>
        <div class="dots" aria-hidden="true">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
      <button *ngIf="!attemptingSilent" mat-stroked-button type="button" class="qlm-login-button"
        (click)="loginWithQlm()">
        Log in with {{ oidcProviderName }}
      </button>
    </edu-card>
  </div>
</div>
